module.exports = __webpack_public_path__ + "static/img/erweima.3c0d803.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/erweima.png
// module id = Nbjv
// module chunks = 1